import {AfterViewInit, Directive, ElementRef, OnDestroy} from '@angular/core';

@Directive({
  selector: '[nzForceRepaint]'
})
export class ForceRepaintDirective implements AfterViewInit, OnDestroy {
  private observer!: MutationObserver;
  private repaintDebounceTimeout!: number;

  constructor(private el: ElementRef<HTMLElement>) {
  }

  public ngAfterViewInit(): void {
    const element: HTMLElement = this.el.nativeElement;
    this.applyRepaint(element);
    this.observer = new MutationObserver(() => {
      clearTimeout(this.repaintDebounceTimeout);
      this.repaintDebounceTimeout = window.setTimeout(() => {
        requestAnimationFrame(() => this.applyRepaint(element));
      }, 50);
    });
    this.observer.observe(element, {
      childList: true,
      subtree: true
    });
  }

  public ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    clearTimeout(this.repaintDebounceTimeout);
  }

  private applyRepaint(element: HTMLElement): void {
    element.style.willChange = 'transform';
    element.style.transform = 'translate3d(0, 0, 0)';
  }
}
